
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3RRKD", function(module, exports) {

$parcel$export(module.exports, "Nav3SpaceApps", () => $40ae02a675acb24f$export$e41d9981e046d50e);
/* Nav3SpaceApps.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $eEA8O = parcelRequire("eEA8O");

var $6xdDU = parcelRequire("6xdDU");

var $3gadb = parcelRequire("3gadb");

var $80xJE = parcelRequire("80xJE");

var $jdPfT = parcelRequire("jdPfT");

var $1Zr9M = parcelRequire("1Zr9M");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $b8XTE = parcelRequire("b8XTE");

var $7aA9P = parcelRequire("7aA9P");

var $4vC63 = parcelRequire("4vC63");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $BRSnR = parcelRequire("BRSnR");

var $ks2xb = parcelRequire("ks2xb");

var $e4o8D = parcelRequire("e4o8D");

var $aWrnw = parcelRequire("aWrnw");

var $cpa7E = parcelRequire("cpa7E");

var $AF127 = parcelRequire("AF127");
const $40ae02a675acb24f$var$i18n = (0, $2nPZH.defineMessages)({
    title: {
        id: "side-navigation.space-apps.header",
        defaultMessage: "Apps"
    },
    editButtonTooltip: {
        id: "side-navigation.space-apps.edit.tooltip",
        defaultMessage: "Reorder, show and hide apps"
    },
    appsTooltip: {
        id: "side-navigation.space-apps.tooltip",
        defaultMessage: "Access apps in this space"
    },
    noAppsMessage: {
        id: "side-navigation.space-apps.no-space-apps.message",
        defaultMessage: "No apps in this space"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40ae02a675acb24f$var$StyledFallbackableImage = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $7aA9P.FallbackableImage), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $40ae02a675acb24f$var$styles = {
    root: "_1yt41nlq _1tke14no _bfhk18uv _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1ydc18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _1x28glyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1 _1726nqa1 _syaz1gjq _9h8h1gjq _f8pj1gjq _30l31gjq _10531gjq _6ehmu2gc _f1537vkz _10ww7vkz _o2hc7vkz _g5127vkz _irr3166n",
    isSelected: "_bfhkfg4m _syazaqb7 _9h8haqb7 _f8pjaqb7 _30l3aqb7 _1053aqb7 _irr3i1yw"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $40ae02a675acb24f$var$AllLinksWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2mzuglyw _lcb2idpf",
            __cmplp.className
        ])
    });
});
const $40ae02a675acb24f$var$MINIMUM_NUMBER_OF_DISPLAYED_LINKS = 2;
const $40ae02a675acb24f$var$LinkItemComponent = ({ link: link, handleClickOnLinkItem: handleClickOnLinkItem })=>{
    const isMatchingCurrentUrlArgs = {
        selector: (url)=>url === link.url
    };
    const matchesUrl = (0, $dPJCf.useRouteUrl)(isMatchingCurrentUrlArgs);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $80xJE.default), {
        key: link.id,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($40ae02a675acb24f$var$StyledFallbackableImage, {
            "data-vc": "space-apps-link-icon",
            src: link?.icon?.path,
            fallback: (0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))),
            role: "presentation"
        }),
        isSelected: !!(link.url && matchesUrl),
        href: link.url || undefined,
        onClick: ()=>handleClickOnLinkItem(link.title),
        className: (0, $35pXk.default)([
            $40ae02a675acb24f$var$styles.root,
            !!(link.url && matchesUrl) && $40ae02a675acb24f$var$styles.isSelected
        ])
    }, link.title);
};
const $40ae02a675acb24f$var$AppLinksComponent = ({ links: links })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [isShowingAll] = (0, $gwFzn.useState)((0, $e9zUf.confluenceLocalStorageInstance)?.getItemAsBoolean((0, $1UApO.keys).SPACENAV_APPS_SHOW_ALL));
    const handleClickOnLinkItem = (appTitle)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'sidebar',
                actionSubjectId: 'appLink',
                attributes: {
                    appTitle: appTitle
                }
            }
        }).fire();
    };
    (0, $gwFzn.useEffect)(()=>{
        (0, $e9zUf.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).SPACENAV_APPS_SHOW_ALL, isShowingAll);
    }, [
        isShowingAll
    ]);
    const linkItems = links.map((link)=>{
        const linkItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($40ae02a675acb24f$var$LinkItemComponent, {
            link: link,
            handleClickOnLinkItem: handleClickOnLinkItem
        }));
        return link.type === (0, $AF127.SpaceSidebarLinkType).FORGE && !renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
            key: link.id,
            module: link
        }, linkItem) : linkItem;
    });
    const forgeKeyboardShortcuts = links.filter((link)=>link.type === (0, $AF127.SpaceSidebarLinkType).FORGE && link.url).map((link)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            key: link.id,
            module: link,
            action: ()=>push(link.url ?? '')
        }));
    if (linkItems.length <= $40ae02a675acb24f$var$MINIMUM_NUMBER_OF_DISPLAYED_LINKS) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, linkItems, !renderServerPlaceholder && forgeKeyboardShortcuts);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, linkItems, !renderServerPlaceholder && forgeKeyboardShortcuts);
};

const $40ae02a675acb24f$var$LazySpaceAppsConfiguration = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "km3gZ",
    name: "LazySpaceAppsConfiguration",
    loader: async ()=>(await (parcelRequire("cl7KL"))).SpaceAppsConfiguration
});
const $40ae02a675acb24f$export$e41d9981e046d50e = /*#__PURE__*/ (0, $gwFzn.memo)(({ isSpaceAdmin: isSpaceAdmin, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, spaceKey: spaceKey })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isOpenAppsConfiguration, setOpenAppsConfiguration] = (0, $gwFzn.useState)(false);
    const noVisibleAppLinks = allVisibleAppLinks.length == 0;
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    if (allAppLinks.length == 0 || noVisibleAppLinks && !isSpaceAdmin) return null;
    const pageSegmentLoadCustomData = {
        connectApps: allVisibleAppLinks.filter((a)=>(0, $cpa7E.isConnectApp)(a)).length,
        forgeApps: allVisibleAppLinks.filter((a)=>(0, $cpa7E.isForgeApp)(a)).length
    };
    const spaceAppsContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $BRSnR.SpacePersistentCollapsibleSectionLoader), {
        renderAfterIconButton: ()=>isSpaceAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $40ae02a675acb24f$var$i18n.editButtonTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
                id: "space-apps-collapsible-section-header-button",
                appearance: "subtle",
                spacing: "none",
                onClick: ()=>setOpenAppsConfiguration(true),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
                    label: "Edit apps"
                })
            })) : null,
        headerTitle: formatMessage($40ae02a675acb24f$var$i18n.title),
        sectionName: "apps",
        tooltipContent: formatMessage($40ae02a675acb24f$var$i18n.appsTooltip)
    }, noVisibleAppLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ks2xb.EmptySidebarCollapsibleSectionLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $40ae02a675acb24f$var$i18n.noAppsMessage)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($40ae02a675acb24f$var$AllLinksWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($40ae02a675acb24f$var$AppLinksComponent, {
        links: allVisibleAppLinks
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "space-apps",
        "data-testid": "space-apps",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
        key: spaceKey,
        metric: (0, $aWrnw.SPACE_APPS_METRIC),
        customData: pageSegmentLoadCustomData
    }), spaceAppsContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6xdDU.default), null, isOpenAppsConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($40ae02a675acb24f$var$LazySpaceAppsConfiguration, {
        links: allAppLinks,
        spaceKey: spaceKey,
        onCancel: ()=>setOpenAppsConfiguration(false),
        onSave: ()=>setOpenAppsConfiguration(false)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null)));
});

});
parcelRegister("cl7KL", function(module, exports) {

let $8fbd75dc4413589c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8fbd75dc4413589c$var$load("ikem6"),
    $8fbd75dc4413589c$var$load("ffEVr"),
    $8fbd75dc4413589c$var$load("joJy8"),
    $8fbd75dc4413589c$var$load("aHE9G"),
    $8fbd75dc4413589c$var$load("hs6o8")
]).then(()=>parcelRequire('kB13O'));

});



//# sourceMappingURL=Nav3SpaceApps.ad018968.js.map
